export enum PLAY_VIDEO_USAGE {
    /**
     * @value Activate Play
     * @description Menu button in the video usage of the backoffice to activate Play on a site
     */
    ACTIVATE_PLAY = 'PLAY.ACTIVATE_PLAY',
    /**
     * @value All sites selected (%NUMBER%)
     * @description When all the sites are selected on the table and if there is no more to be fetched
     */
    ALL_SITES_SELECTED = 'PLAY.ALL_SITES_SELECTED',
    /**
     * @value Cannot exceed the platform quota (%NUMBER%)
     * @description Error message on a form when the site quota exceed the organization quota
     */
    CANNOT_EXCEED_QUOTA = 'PLAY.CANNOT_EXCEED_QUOTA',
    /**
     * @value China optimized videos
     * @description Label for a chart showing China video usage
     */
    CHINA_VIDEOS = 'PLAY.CHINA_VIDEOS',
    /**
     * @value {"one":"You can store %NB% China optimized video on your site.","other":"You can store %NB% China optimized videos on your site."}
     */
    CHINA_VIDEOS_COUNT = 'PLAY.CHINA_VIDEOS_COUNT',
    /**
     * @value Corporate videos
     * @description Title of columns for video usage section
     */
    CORPORATE_VIDEOS = 'PLAY.CORPORATE_VIDEOS',
    /**
     * @value Deactivate Play
     * @description Menu button in the video usage of the backoffice to deactivate Play on a site
     */
    DEACTIVATE_PLAY = 'PLAY.DEACTIVATE_PLAY',
    /**
     * @value {"one":"Deactivating Play on this <b>site<\/b> will remove their access to the following features:","other":"Deactivating Play on these <b>%NUMBER% sites<\/b> will remove their access to the following features:"}
     * @description Deactivate play feature
     */
    DEACTIVATE_PLAY_FEATURE_DESCRIPTION = 'PLAY.DEACTIVATE_PLAY_FEATURE_DESCRIPTION',
    /**
     * @value Display header icon
     * @description Text for the edit setting modal in video usage
     */
    DISPLAY_HEADER_ICON = 'PLAY.DISPLAY_HEADER_ICON',
    /**
     * @value Edit quota
     * @description Menu button in the video usage of the backoffice to edit the quota of a site
     */
    EDIT_QUOTA = 'PLAY.EDIT_QUOTA',
    /**
     * @value Edit quotas
     * @description Title of the edit quotas dialog and an action you can do on the bulk selection menu
     */
    EDIT_QUOTAS = 'PLAY.EDIT_QUOTAS',
    /**
     * @value {"one":"You can store %NB% video across all your communities.","other":"You can store %NB% videos across all your communities."}
     */
    EMPLOYEES_VIDEOS_COUNT = 'PLAY.EMPLOYEES_VIDEOS_COUNT',
    /**
     * @value Employee videos
     * @description Label for a chart showing Employee video usage
     */
    EMPLOYEE_VIDEOS = 'PLAY.EMPLOYEE_VIDEOS',
    /**
     * @value Please note that each Optimized video counts both toward your Optimized video quota and your Corporate video quota.
     * @description Explain how the optimized videos quota is depleted, used in the videos usage cards of the platform overview
     */
    OPTIMIZED_VIDEOS_QUOTA_NOTICE = 'PLAY.OPTIMIZED_VIDEOS_QUOTA_NOTICE',
    /**
     * @value Optimized videos
     * @description Title of a column for video usage section
     */
    OPTMIZED_VIDEOS = 'PLAY.OPTIMIZED_VIDEOS',
    /**
     * @value Platform overview
     */
    PLATFORM_OVERVIEW = 'LOOKER_PLATFORM_OVERVIEW_DASHBOARD_TITLE',
    /**
     * @value Platform usage
     * @description Title of the platform usage section
     */
    PLATFORM_USAGE = 'PLAY.PLATFORM_USAGE',
    /**
     * @value {"one":"You can store %nb% video on your site.","other":"You can store %NB% videos on your site."}
     */
    PLATFORM_VIDEOS_COUNT = 'PLAY.PLATFORM_VIDEOS_COUNT',
    /**
     * @value Play settings
     * @description Menu button in the video usage of the backoffice to edit the settings of a site
     */
    PLAY_SETTINGS = 'PLAY.PLAY_SETTINGS',
    /**
     * @value Play status
     * @description Title of the column to indicate the status of the site either activated or deactivated
     */
    PLAY_STATUS = 'PLAY.PLAY_STATUS',
    /**
     * @value This site has exceeded its assigned video quota.
     * Delete some videos or increase the site's quota.
     * @description Warning message displayed if a site exceed one of his quotas
     */
    QUOTA_EXCEEDED_WARNING = 'PLAY.QUOTA_EXCEEDED_WARNING',
    /**
     * @value If empty the site's quota will be unrestricted
     */
    QUOTA_UNRESTRICTED_IF_EMPTY = 'PLAY.QUOTA_UNRESTRICTED_IF_EMPTY',
    /**
     * @value Show only sites with videos
     * @description Text for the dialog component in the video-usage section to filter sites with and without videos
     */
    SHOW_SPECIFIC_SITE = 'PLAY.SHOW_SPECIFIC_SITE',
    /**
     * @value %NUMBER% sites out of many
     * @description Display the number of sites in the video usage table
     */
    SITES_OUT_OF_MANY = 'PLAY.SITES_OUT_OF_MANY',
    /**
     * @value {"one":"%NUMBER% site selected","other":"%NUMBER% sites selected"}
     * @description When selecting a number of sites from the play video usage page we display the number of sites selected
     */
    SITES_SELECTED = 'PLAY.SITES_SELECTED',
    /**
     * @value %NUMBER% sites selected out of many
     * @description Title showing when all sites are selected but more can be fetch on the table of video quota and settings
     */
    SITES_SELECTED_OUT_OF_MANY = 'PLAY.SITES_SELECTED_OUT_OF_MANY',
    /**
     * @value Unable to display the page
     * @description Page title informing the user that the page is not available ( available only for video usage section)
     */
    UNABLE_TO_DISPLAY_PAGE = 'PLAY.UNABLE_TO_DISPLAY_PAGE',
    /**
     * @value Uploading video
     */
    UPLOADING_VIDEO = 'PLAY.UPLOADING_VIDEO',
    /**
     * @value Usage per site
     * @description Title of the usage per site section
     */
    USAGE_PER_SITES = 'PLAY.USAGE_PER_SITES',
    /**
     * @value You can store %NUMBER% videos across your entire platform.
     * @description Indicate how many videos can be stored for each category of videos
     */
    VIDEOS_PLATFORM_LIMIT = 'PLAY.VIDEOS_PLATFORM_LIMIT',
    /**
     * @value Videos used
     * @description Tooltip to indicate on the multiprogress bar the number of videos used
     */
    VIDEOS_USED = 'PLAY.VIDEOS_USED',
    /**
     * @value You have used more than 90% of your video allowance. You can contact your platform administrator to increase the allowance.
     * @description Warning message indicating that the maximum number of videos has already been reached
     */
    VIDEOS_USED_WARNING_ALLOWANCE = 'PLAY.VIDEO_USAGE_WARNING_ALLOWANCE',
    /**
     * @value All videos of the site will still be accessible in context.
     */
    VIDEO_ACCESSIBILITY_CONTEXT = 'PLAY.VIDEO_ACCESSIBILITY_CONTEXT',
    /**
     * @value Video analytics
     */
    VIDEO_ANALYTICS = 'LOOKER_VIDEO_DASHBOARD_TITLE',
    /**
     * @value The video quota for your platform has not been set, please contact technical support.
     * @description Text in an alert message to inform the user that the quota has not yet been installed
     */
    VIDEO_QUOTA_NOT_CONFIGURED = 'PLAY.VIDEO_QUOTA_NOT_CONFIGURED',
    /**
     * @value Video usage
     * @description Name of the tab opening the Video Usage panel
     */
    VIDEO_USAGE = 'PLAY.VIDEO_USAGE',
    /**
     * @value You are exceeding the storage capacity in your contract
     */
    VIDEO_USAGE_EXCEEDED = 'PLAY.VIDEO_USAGE_EXCEEDED',
    /**
     * @value Usage statistics are currently unavailable for your account, please contact technical support
     */
    VIDEO_USAGE_UNAVAILABLE = 'PLAY.VIDEO_USAGE_UNAVAILABLE',
    /**
     * @value You have used 90% of your video allowance. You can contact your platform administrator to increase the allowance.
     * @description Warning message informing that the max number of videos will soon be reached
     */
    VIDEO_USAGE_WARNING_MESSAGE = 'PLAY.VIDEO_USAGE_WARNING_MESSAGE',
}
